export const patchChangeDeviceText = {
  successDescriptionText: 'Berhasil mengubah perangkat',
  defaultErrorMessageText: 'Gagal mengubah perangkat',
};

export const postEndBreakText = {
  getSuccessDescriptionText: ({ time, isBreak }) => `${isBreak ? 'Istirahat kamu selesai dalam' : 'Waktu Bantu Rekan kamu selesai dalam'} ${time}`,
  defaultErrorMessageText: 'Gagal mengakhiri break',
};

export const postStartBreakText = {
  successDescriptionText: 'Berhasil memulai break',
  defaultErrorMessageText: 'Gagal memulai break',
};

export const postPresenceClockInText = {
  getOnTimePresenceClockInText: (time) => `Absen masuk berhasil pukul ${time}`,
  getLatePresenceClockIn: (time) => `Absen masuk berhasil pukul ${time} Kamu tercatat datang terlambat.`,
  defaultErrorMessageText: 'Gagal presence clock in',
};

export const postPresenceClockOutText = {
  getOnTimePresenceClockOutText: (time) => `Clock out berhasil pukul ${time}`,
  getPresenceClockOutViolation: (time) => `Clock out berhasil pukul ${time}. Kamu tercatat pulang tidak sesuai jadwal.`,
  defaultErrorMessageText: 'Gagal clock out',
};
